import { createAction, props } from '@ngrx/store';

import { StockToteListPagination, StockToteListSearchCriteria } from '../models/stock-tote-list.model';
import { StockToteSummaryResponse } from '../models/stock-tote.model';

export const StockToteAction = {
  stockToteSummaryRequest: createAction('[Stock Tote] stock tote summary request'),
  stockToteSummaryResponse: createAction(
    '[Stock Tote] stock tote summary response',
    props<{ response: StockToteSummaryResponse }>()
  ),
  stockToteListRequest: createAction(
    '[Stock Tote] stock tote list request',
    props<{ payload: StockToteListSearchCriteria }>()
  ),
  stockToteListResponse: createAction(
    '[Stock Tote] stock tote list response',
    props<{ response: StockToteListPagination }>()
  )
};
